<template>
	<!-- </div>style="top: calc(30px); left: calc(140px);"> -->
	<div v-if="isShow" ref="overlay" class="rsv2_info_overlay" :style="positionStyle">
		<div class="main_info">
			<div class="user_info ellipsis">
				<div class="top">
					<div class="name ellipsis">{{ getCustomerNameString }}</div>
					<div class="chartnum ellipsis" v-if="isUsingChartNumber"> ({{ getChartNumberString }})</div>
				</div>
				<div class="bottom">
					<div class="gen_birth">{{ getGenderAndBirthString }}</div>
				</div>
			</div>
			<div class="rsv_status" style="background-color: #ff0000; color: #fff" v-if="isCancel">
				{{ $t('popup_reservation_preview.label_cancel_appointment') }}
			</div>
		</div>
		<div class="sub_info" :class="{ 'hr': !isUsingFirstVisitStartDate && !isUsingUserTag }">
			<div class="title">{{ $t('popup_reservation_preview.label_phone') }}</div>
			<div class="txt">{{ getPhoneString }}</div>
		</div>
		<div class="sub_info" :class="{ 'hr': !isUsingUserTag }" v-if="isUsingFirstVisitStartDate">
			<div class="title">{{ $t('popup_reservation_preview.label_class') }}</div>
			<div class="txt">{{ getFirstVisitTypeString }}</div>
		</div>
		<div class="sub_info hr" v-if="isUsingUserTag">
			<div class="title">{{ $t('popup_reservation_preview.label_patient_tag') }}</div>
			<div class="txt">{{ getTagString }}</div>
		</div>
		<div class="sub_info">
			<div class="title">{{ $t('popup_reservation_preview.label_appointment_date_time') }}</div>
			<div class="txt">{{ getReservationString }}</div>
		</div>
		<div class="sub_info">
			<div class="title">{{ $t('popup_reservation_preview.label_department') }}</div>
			<div class="txt">{{ getGroupString }}</div>
		</div>
		<div class="sub_info">
			<div class="title">{{ $t('popup_reservation_preview.label_staff') }}</div>
			<div class="txt">{{ getColumnString }}</div>
		</div>
		<div class="sub_info">
			<div class="title">{{ $t('popup_reservation_preview.label_program') }}</div>
			<div class="txt">{{ getProgramString }}</div>
		</div>
		<div class="sub_info">
			<div class="title">{{ $t('popup_reservation_preview.label_first_registered') }}</div>
			<div class="txt"><span class="ellipsis" style="max-width: 50%">{{ getReceptionReservationString
					}}</span><span class="ellipsis"> / {{ getReceptionReservationDate }}</span></div>
		</div>
		<div class="sub_info hr">
			<div class="title">{{ $t('popup_reservation_preview.label_last_modified') }}</div>
			<div class="txt"><span class="ellipsis" style="max-width: 50%">{{
				getReceptionReservationModifierString }}</span><span class="ellipsis"> / {{
						getReceptionReservationUpdatedAt }}</span></div>
		</div>
		<div class="sub_info hr column">
			<div class="title">{{ $t('popup_reservation_preview.label_appointment_memo') }}</div>
			<div class="txtarea">
				{{ getMemoString }}
			</div>
		</div>
		<div class="sub_info column">
			<div class="title">{{ $t('popup_reservation_preview.label_medical_history') }}</div>
			<div class="txtarea">
				{{ getNoteString }}
			</div>
		</div>
	</div>
</template>

<script>
import { formatPhone } from '@/util/format-phone'
import { mapState } from "vuex";
const moment = require("@/util/MPMoment");

export default {
	props: {
		isShow: Boolean,
		isEnterSheet: Boolean,
		reservation: Object,
		hoverEvent: Object,
	},
	data() {
		return {};
	},
	watch: {},
	computed: {
		...mapState(["servicesetting", "SaaS"]),

		isWindow: function () {
			return this.SaaS?.isWindow ?? false;
		},
		isCancel: function () {
			return this.reservation?.statusID?.isCancelStatus;
		},
		isUsingChartNumber: function () {
			return this.servicesetting?.setting?.usingChartNumber ?? false;
		},
		isUsingFirstVisitStartDate: function () {
			return this.servicesetting?.setting?.usingFirstVisitStartDate ?? false;
		},
		isUsingUserTag: function () {
			return this.servicesetting?.setting?.usingUserTag ?? false;
		},
		hservice: function () {
			return this.reservation?.hserviceID;
		},
		getCustomerNameString: function () {
			const hserviceName = this.reservation?.hserviceID?.name
			return hserviceName ?? this.reservation?.userName
		},
		getChartNumberString: function () {
			return this.hservice?.chartNumber ?? "";
		},
		getGenderAndBirthString() {
			if (
				this.hservice?.gender == undefined ||
				this.hservice?.birth == undefined
			) {
				return "-";
			}
			let gender = "";
			if (this.hservice?.gender == "M") {
				gender = this.$t('common.male_short');
			} else if (this.hservice?.gender == "F") {
				gender = this.$t('common.female_short');
			}
			let birth = this.hservice?.birth?.substr(2) ?? "-";
			return gender + "/" + birth;
		},
		getCountries: function () {
			const list = this.$store.state.servicesetting.countries;
			return Array.isArray(list) ? list : [];
		},
		getCountryCodeId: function () {
			// KR fallback 을 두지 않는다 — 국가코드가 없으면 접두 없이 국내 포맷으로 표시 (기존 동작)
			return this.service?.countryCode?._id;
		},
		getCountryDialingCode() {
			if (!this.isWindow) return "";

			const code = this.hservice?.countryCode?.internationalDialingCodes;
			if (code) {
				return `(+${code})`;
			}

			// 국가 목록 API 는 _id 를 countryId 로 리네임해 내려준다
			// (이 컴포넌트의 computed 명은 getCountries — this.countries 는 존재하지 않아 크래시했었음)
			const country = this.getCountries.find(c => c.countryId == this.getCountryCodeId);
			if (country) {
				return `(+${country.internationalDialingCodes})`;
			}
			return "";
		},
		getPhoneString() {
			const phoneRaw = this.hservice?.phone;
			if (!phoneRaw) return "-";

			if (this.getCountryDialingCode) {
				return `${this.getCountryDialingCode} ${phoneRaw}`;
			}
			return formatPhone(phoneRaw) || "-";
		},
		getFirstVisitTypeString() {
			if (this.hservice.isFirstVisit == undefined) {
				return "-";
			}
			return this.hservice.isFirstVisit == true ? this.$t('common.initial') : this.$t('common.return');
		},
		getTagString() {
			let returnValue = "";
			for (let i = 0; i < this.hservice.userTagIDs.length; i++) {
				if (!this.hservice.userTagIDs[i]?.name) {
					continue;
				}
				if (returnValue != "") {
					returnValue += ", ";
				}
				returnValue += this.hservice.userTagIDs[i].name;
			}
			if (returnValue.length == 0) {
				return "-";
			}
			return `${returnValue}`;
		},
		getReservationString() {
			if (!this.reservation?.startedAt) {
				return;
			}
			let startedAt = moment(this.reservation.startedAt).format(
				this.$t('popup_reservation_preview.date_format_str'),
			);
			let endedAt = moment(this.reservation.startedAt)
				.add(this.reservation.duration, "minutes")
				.format("HH:mm");
			return startedAt + " ~ " + endedAt;
		},
		getGroupString() {
			return this.reservation?.groupTitle;
		},
		getColumnString() {
			return this.reservation?.columnTitle;
		},
		getProgramString() {
			const found = this.reservation.columnID.programs.some((programId) =>
				programId == this.reservation.programID._id
			);
			return found ? this.reservation.programTitle : '미선택';
		},
		getReceptionReservationString() {
			if (this.reservation?.writerType == 1000) {
				return "고객";
			} else if (this.reservation?.writerType >= 3000) {
				return "애프터닥";
			}
			return this.reservation?.writerID?.realName ?? "-";
		},
		getReceptionReservationDate() {
			if (this.reservation?.createdAt == undefined) {
				return "-";
			}
			return moment(this.reservation?.createdAt).format(this.$t('popup_reservation_preview.date_format'));
		},
		getReceptionReservationModifierString() {
			if (this.reservation?.modifierType == 1000) {
				return "고객";
			} else if (this.reservation?.modifierType >= 3000) {
				return "애프터닥";
			}
			return this.reservation?.modifierID?.realName ?? "-";
		},
		getReceptionReservationUpdatedAt() {
			if (this.getReceptionReservationModifierString == "-") {
				return "-";
			}
			if (this.reservation?.updatedAt == undefined) {
				return "-";
			}
			return moment(this.reservation?.updatedAt).format(this.$t('common.date_format_YYYY_MM_DD_HH_mm'));
		},
		getMemoString: function () {
			return this.reservation?.note || '';
		},
		getNoteString: function () {
			return this.reservation?.userTreatmentMemo || '';
		},
		positionStyle: function () {
			const popupWidth = 350;
			const popupHeight = 495;

			if (this.isEnterSheet) {
				const positionForLeft =
					this.hoverEvent.ref.clientWidth + this.hoverEvent.ref.scrollLeft;
				const positionForTop =
					this.hoverEvent.ref.clientHeight + this.hoverEvent.ref.scrollTop + 20;

				const offsetX =
					positionForLeft < this.hoverEvent.x + popupWidth ? -365 : 0;
				const offsetY =
					positionForTop < this.hoverEvent.y + popupHeight ? -popupHeight : 0;

				return `left: ${this.hoverEvent.x + offsetX}px; top: ${this.hoverEvent.y + offsetY}px;`;
			} else {
				const offsetX =
					window.innerWidth < this.hoverEvent.x + popupWidth ? -390 : 0;
				return `left: ${this.hoverEvent.x + offsetX}px;`;
			}
		},
	},
	methods: {},
};
</script>